import "./styles.css";
import { mount } from "./app.js";
import { isDocsPath, mountDocsPortal } from "./docs-portal.js";
import { isJoinPath, mountJoinPage } from "./join-page.js";
import { isSignupPath, mountSignupPage } from "./signup-page.js";

const root = document.getElementById("app");
if (!root) {
  throw new Error("#app root element missing");
}

if (isDocsPath()) {
  mountDocsPortal(root);
} else if (isSignupPath()) {
  mountSignupPage(root);
} else if (isJoinPath()) {
  mountJoinPage(root);
} else {
  mount(root);
}
